import repository from '@/repositories/repository'

export default baseUrl => {
    baseUrl = `${baseUrl}/perfil`

    return {
        edit() {
            return repository.get(`${baseUrl}/edit`)
        },
        update(params) {
            return repository.patch(`${baseUrl}`, params)
        },
    }
}